import ReviewSubjectRelationView from './ReviewSubjectRelationView'

export default ReviewSubjectRelationView
